import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  LabelList,
} from "recharts";
import { ButtonFilled } from "../../../Reusablecomponents/UIButtons";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import StyledTable from "../../../Reusablecomponents/UITable/UITable";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import styled from "styled-components";
import {
  Input,
  Modal,
  Badge,
  Avatar,
  Form,
  Select,
  DatePicker,
  Space,
  Card,
  Row,
  Col,
  Spin,
  message,
} from "antd";
import upload from "../../../assets/images/upload.svg";
import legco2 from "../../../assets/images/kindpng_925383 1.svg";
import UIModal from "../../../Reusablecomponents/UIModal";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import { TripTypeEnum } from "../../../Common/constant";
import { useSelector } from "react-redux";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import { CALL_API } from "../../../Common/api";
import dayjs from "dayjs";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { CSVLink } from "react-csv";
const Customstyle = styled.div`
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .dropstyle {
    margin-top: 20px !important;
    width: 250px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 250px !important;
  }
  .head1 {
    font-size: 16px;
    font-weight: 400;
  }
  .textstyle {
    font-size: 16px;
    font-weight: 500;
  }
  .head2 {
    color: #5f6d8c;
  }
  .badg-hover-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: -2px;
  }
  .hoverimage1 {
    margin-top: -15px;
  }
  @media (max-width: 768px) {
    .head {
      flex-direction: column; /* Stack items vertically */
      align-items: flex-start; /* Align items to the left */
    }

    .head1 {
      font-size: 16px; /* Adjust font size for smaller screens */
      width: 100%; /* Take full width */
      margin-bottom: 10px; /* Add spacing below */
    }

    .Custom {
      justify-content: space-between; /* Space items evenly */
      width: 100%; /* Take full width */
    }

    .dropstyle,
    .dropstyle1 {
      flex: 1; /* Allow dropdowns to expand */
      min-width: unset !important; /* Remove fixed width */
    }

    .hover-image {
      margin-top: 10px; /* Add spacing for better layout */
    }
  }
  @media (max-width: 480px) {
    .Custom {
      flex-direction: column; /* Stack items vertically */
      align-items: flex-start; /* Align items to the left */
      gap: 10px; /* Adjust spacing between elements */
    }

    .dropstyle1 {
      flex: 1 !important; /* Allow dropdowns to expand */
      width: unset !important; /* Remove fixed width */
      width: 100% !important;
    }
    .dropstyle {
      flex: 1 !important; /* Allow dropdowns to expand */
      min-width: unset !important; /* Remove fixed width */
      width: 100% !important;
    }

    .badg {
      margin-top: 10px;
    }
    .hover-image,
    .badg {
      width: auto; /* Ensure these items don't stretch unnecessarily */
    }
    .tooltipContainer {
      position: relative;
      display: inline-block;
      textalign: center;
    }
    .arrowDown {
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      borderleft: 8px solid transparent;
      borderright: 8px solid transparent;
      borderbottom: 8px solid #ffffff;
      zindex: 1;
    }
    .tooltipcontent: {
      background: #ffffff;
      color: #333;
      padding: 10px 12px;
      borderradius: 8px;
      boxshadow: 0 2px 10px rgba(0, 0, 0, 0.15);
      fontsize: 13px;
      minwidth: 100px;
      zindex: 2;
    }
    .label {
      fontweight: bold;
      marginbottom: 5px;
    }
    item {
      display: flex;
      justifycontent: space-between;
      gap: 4px;
    }
    /* Place .badg and .hover-image in one row */
    .badg-hover-wrapper {
      display: flex;
      justify-content: flex-start; /* Align items to the left */
      align-items: center; /* Vertically center elements */
      gap: 10px; /* Add spacing between .badg and .hover-image */
      width: 100%; /* Take full width */
    }
  }
  @media (max-width: 1024px) {
    .legend-image {
      display: none;
    }
  }
`;

function Carbonfootprints() {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [selectedDate, setSelectedDate] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [chartData, setChartData] = useState({});
  const [TableData, setTableData] = useState({});
  const [loading, setLoading] = useState(false);
  const [duration, setDuration] = useState("current_month");
  const [openmodal, SetOpenmodal] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [currentPage, setCurrentPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [PageSize, setPageSize] = useState(10);
  //pagination function
  const handlePageChange = (page, PageSize) => {
    setCurrentPage(page);
    setPageSize(PageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("TCFRPT", "EX"),
    [reduxPermissions],
  );
  //chart api calling function
  const getcarbonfootprintChart = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `carbonfootprint/get_carbon_chart?MCID=${
        userInfo?.MCID
      }&startDate=${dayjs(selectedDate?.[0]).format(
        "YYYY-MM-DD",
      )}&endDate=${dayjs(selectedDate?.[1]).format("YYYY-MM-DD")}`,
      {
        VEHID: formValues?.vehicle || 0,
        TRIPTYPE: formValues?.tripType || 0,
        CUST: formValues?.consignor || 0,
        SHIPPER: formValues?.transporter || 0,
        DRIVER: formValues?.driver || 0,
        RECEIVER: formValues?.consignee || 0,
        TRIPCODE: formValues?.trip || " ",
      },
    );
    setChartData(data);
    setLoading(false);
  };

  const getcarbonfootprintTable = async () => {
    try {
      setLoading(true);

      const startDate = dayjs(selectedDate?.[0]).format("YYYY-MM-DD");
      const endDate = dayjs(selectedDate?.[1]).format("YYYY-MM-DD");

      const { data } = await CALL_API(
        "POST",
        `carbonfootprint/get_carbon_Table?MCID=${userInfo?.MCID}&startDate=${startDate}&endDate=${endDate}&page=${currentPage}&PageSize=${PageSize}`,
        {
          VEHID: formValues?.vehicle || 0,
          TRIPTYPE: formValues?.tripType || 0,
          CUST: formValues?.consignor || 0,
          SHIPPER: formValues?.transporter || 0,
          DRIVER: formValues?.driver || 0,
          RECEIVER: formValues?.consignee || 0,
          TRIPCODE: formValues?.trip || "",
        },
      );

      setTableData(data);
      setTotal(data?.CarbonTable?.[0]?.TotalCount || 0); // Updated: pulls from CarbonTable, since totalCount is not in root
    } catch (error) {
      console.error("Error fetching Carbon Footprint table data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(formValues).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };

  const formatPickupDateTime = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (isNaN(date)) return "-";

    const options = { day: "numeric", month: "short", year: "numeric" };
    const dateString = date.toLocaleDateString("en-US", options);
    const timeString = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${dateString} ${timeString}`;
  };

  const formatMinutes = (value) => {
    if (value == null || isNaN(value)) return "-";
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  //  export functionality for carboonFootprint report tabel
  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const startDate = dayjs(selectedDate?.[0]).format("YYYY-MM-DD");
      const endDate = dayjs(selectedDate?.[1]).format("YYYY-MM-DD");

      const { data } = await CALL_API(
        "POST",
        `carbonfootprint/get_carbon_Table?MCID=${userInfo?.MCID}&startDate=${startDate}&endDate=${endDate}&page=1&PageSize=${total}`,
        {
          VEHID: formValues?.vehicle || 0,
          TRIPTYPE: formValues?.tripType || 0,
          CUST: formValues?.consignor || 0,
          SHIPPER: formValues?.transporter || 0,
          DRIVER: formValues?.driver || 0,
          RECEIVER: formValues?.consignee || 0,
          TRIPCODE: formValues?.trip || "",
        },
      );
      if (data?.CarbonTable?.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.CarbonTable);

        setCSVList(
          sortedData?.map((item) => ({
            "Trip Code": item.TRIPCODE || "-",
            "Pickup Date and Time":
              formatPickupDateTime(item.PickupDateTime) || "-",
            Vehicle: item.REGNO || "-",
            "Carbon Footprint (KgCo2)": item.CarbonFootprint || "-",
            "Driver Name": item.DRIVERNAME || "-",
            "Trip Type": item.TRIPTYPE
              ? item.TRIPTYPE === 1
                ? "Local"
                : "Safari"
              : "-",
            "ODO (KMS) ": item.ODOKMS || "-",
            "Break Time": formatMinutes(item.BreakTime) || "-",
            "Avg Trip Time": formatMinutes(item.AVGTRIPTIME) || "-",
          })),
        );
        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
      message.error(
        "Failed to prepare CSV. " + (error?.response?.data?.message || ""),
      );
    } finally {
      setCSVLoader(false);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getcarbonfootprintChart();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getcarbonfootprintChart();
      getcarbonfootprintTable(currentPage, PageSize);
      getFilterCount();
    }
  }, [formValues, selectedDate, currentPage, PageSize]);

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  //customized Tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="tooltipContainer">
          <div className="arrowDown" />
          <div className="tooltipContent">
            <div className="label">{label}</div>
            {payload.map((entry, index) => (
              <div key={index} className="item">
                {/* <span>{entry.name}:</span> */}
                <strong> {entry.value}</strong>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };
  // const data = [
  //   { name: "Pwani Oil Mombasa", uv: 8 },
  //   { name: "Pwani Oil Mombasa", uv: 20 },
  //   { name: "Pwani Oil Mombasa", uv: 10 },
  //   { name: "Pwani Oil Mombasa", uv: 17 },
  //   { name: "Pwani Oil Mombasa", uv: 2 },
  //   { name: "Pwani Oil Mombasa", uv: 10 },
  //   { name: "Pwani Oil Mombasa", uv: 4 },
  //   { name: "Pwani Oil Mombasa", uv: 16 },
  //   { name: "Pwani Oil Mombasa", uv: 6 },
  //   { name: "Pwani Oil Mombasa", uv: 8 },
  //   { name: "Pwani Oil Mombasa", uv: 20 },
  //   { name: "Pwani Oil Mombasa", uv: 6 },
  //   { name: "Pwani Oil Mombasa", uv: 8 },
  //   { name: "Pwani Oil Mombasa", uv: 20 },
  // ];
  // const data1 = [
  //   { name: "KA12345", uv: 2 },
  //   { name: "KA12346", uv: 10 },
  //   { name: "KA12347", uv: 4 },
  //   { name: "KA12348", uv: 16 },
  //   { name: "KA12349", uv: 6 },
  //   { name: "KA12350", uv: 8 },
  //   { name: "KA12351", uv: 20 },
  //   { name: "KA12352", uv: 10 },
  //   { name: "KA12353", uv: 17 },
  //   { name: "KA12345", uv: 2 },
  //   { name: "KA12346", uv: 10 },
  //   { name: "KA12347", uv: 4 },
  //   { name: "KA12348", uv: 16 },
  //   { name: "KA12349", uv: 6 },
  //   { name: "KA12350", uv: 8 },
  //   { name: "KA12351", uv: 20 },
  // ];
  const VerticalChart = ({ data, width, height, barColor, dataKey, type }) => {
    return (
      <ResponsiveContainer width={width} height={height}>
        <BarChart
          layout="vertical"
          margin={{ top: 10, right: 50, left: -20, bottom: 10 }}
          barSize={25}
          data={data}
        >
          <CartesianGrid vertical={false} horizontal={false} />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            domain={[0, 20]}
            // ticks={[0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20]}
            interval={0}
            tick={{
              fontSize: 12, // Adjust font size if needed
              textAnchor: "start", // Align text to end for better readability
            }}
            tickFormatter={(value) => Math.round(value)}
          />
          <YAxis
            type="category"
            dataKey="Vehicle_No"
            axisLine={false}
            tickLine={false}
            width={150}
            tick={{
              fontSize: 12, // Adjust font size if needed
              textAnchor: "end", // Align text to end for better readability
            }}
            label={{
              value: "(KgCO2)", // Text you want to display
              angle: 0, // Keep the text horizontal
              position: "bottom", // Position it below the Y-axis labels
              offset: 8, // Adjust spacing
              dx: 35, // Move the text slightly to the right

              style: { fontSize: 14, fill: "#000" }, // Customize text appearance
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill={barColor}
            radius={5}
            style={{ cursor: "pointer" }}
          >
            <LabelList
              content={({ x, y, width, value }) => (
                <text
                  x={x + width + 5} // 5px padding to the right of the bar
                  y={y + 14} // vertically center the label in the bar
                  fill="#000"
                  fontSize={12}
                >
                  {Math.round(value)}
                </text>
              )}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };
  const COLORS = [
    "#FFCE4F",
    "#4FFFE2",
    "#F64FFF",
    "#FF4F52",
    "#63FF4F",
    "#FFFC4F",
    "#5A56E9",
  ];
  // const pieChartData = [
  //   { name: "Truck", value: 12 },
  //   { name: "Pickup", value: 12 },
  //   { name: "Trailer", value: 12 },
  //   { name: "Van", value: 12 },
  //   { name: "Saloon Car", value: 12 },
  //   { name: "Motor Cycle", value: 12 },
  //   { name: "Tuk Tuk", value: 12 },
  // ];
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    index,
    percent,
    payload,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.16;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const ishrline = Math.cos(-midAngle * RADIAN) > 0;
    const lineLength = ishrline ? 100 : -100;
    const textOffset = ishrline ? 20 : -20;
    const color = COLORS[index % COLORS.length];
    const squareSize = 12;

    return (
      <>
        {/* Anchor line */}
        <line
          x1={x}
          y1={y}
          x2={x + lineLength}
          y2={y}
          stroke="#ccc"
          strokeWidth={1}
        />
        <rect
          x={x + lineLength + (ishrline ? -squareSize - 0 : 0)}
          y={y - squareSize / 2}
          width={squareSize}
          height={squareSize}
          fill={color}
        />
        <text
          x={x + lineLength + textOffset}
          y={y}
          fill="#5F6D8C"
          textAnchor={ishrline ? "start" : "end"}
          dominantBaseline="central"
          fontSize={15}
        >
          <tspan>{payload.DATA} </tspan>
          <tspan fill="black" fontWeight="bold">
            {Math.round(payload.VAL)}
          </tspan>
        </text>
      </>
    );
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        [
          "TRIPTYPE",
          "ODOKMS",
          "BreakTime",
          "AVGTRIPTIME",
          "CarbonFootprint",
        ].includes(tableSort.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const OfficeColumn = [
    {
      title: "Trip Code",
      dataIndex: "TRIPCODE",
      key: "TRIPCODE",
      sorter: (a, b) => (a.TRIPCODE || "").localeCompare(b.TRIPCODE || ""),
      sortOrder: tableSort.field === "TRIPCODE" ? tableSort.order : null,
    },
    {
      title: "Pickup Date and Time",
      dataIndex: "PickupDateTime",
      key: "PickupDateTime",
      sorter: (a, b) =>
        (a.PickupDateTime || "").localeCompare(b.PickupDateTime || ""),
      sortOrder: tableSort.field === "PickupDateTime" ? tableSort.order : null,
      render: (value) => {
        const date = new Date(value);
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      sorter: (a, b) => (a.REGNO || "").localeCompare(b.REGNO || ""),
      sortOrder: tableSort.field === "REGNO" ? tableSort.order : null,
    },
    {
      title: "Driver Name",
      dataIndex: "DRIVERNAME",
      key: "DRIVERNAME",
      sorter: (a, b) => (a.DRIVERNAME || "").localeCompare(b.DRIVERNAME || ""),
      sortOrder: tableSort.field === "DRIVERNAME" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "TRIPTYPE",
      key: "TRIPTYPE",
      sorter: (a, b) => (a.TRIPTYPE || 0) - (b.TRIPTYPE || 0),
      sortOrder: tableSort.field === "TRIPTYPE" ? tableSort.order : null,
      render: (type) => (type === 1 ? "Local" : "Safari"),
    },
    {
      title: "Carbon Footprint (KgCO2)",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      sorter: (a, b) => (a.CarbonFootprint || "") - (b.CarbonFootprint || ""),
      sortOrder: tableSort.field === "CarbonFootprint" ? tableSort.order : null,
    },
    {
      title: "ODO (Kms)",
      dataIndex: "ODOKMS",
      key: "ODOKMS",
      sorter: (a, b) => (a.ODOKMS || 0) - (b.ODOKMS || 0),
      sortOrder: tableSort.field === "ODOKMS" ? tableSort.order : null,
    },
    {
      title: "Break Time",
      dataIndex: "BreakTime",
      key: "BreakTime",
      sorter: (a, b) => (a.BreakTime || 0) - (b.BreakTime || 0),
      sortOrder: tableSort.field === "BreakTime" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
    {
      title: "Avg Trip Time",
      dataIndex: "AVGTRIPTIME",
      key: "AVGTRIPTIME",
      sorter: (a, b) => (a.AVGTRIPTIME || 0) - (b.AVGTRIPTIME || 0),
      sortOrder: tableSort.field === "AVGTRIPTIME" ? tableSort.order : null,
      render: (value) => formatMinutes(value),
    },
  ];

  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );

  const handleclickfilter = () => {
    SetOpenmodal(true);
  };

  const [formData, setFormData] = useState({
    consignor: "",
    transporter: "",
    consignee: [{}],
    chargetype: "",
    priority: "",
    noofdeliverables: "",
    dimension: "",
    gross: "",
    switch: false,
    plocation: "",
    pdate: "",
    dlocation: "",
    ddate: "",
    pnotes: "",
    dnotes: "",
    remark: "",
    linkdossier: "",
    orderno: "",
    referenceno: "",
    containerno: "",
    zone: "",
    dlocationname: {},
    plocationname: {},
  });

  const apiData1 =
    chartData?.carboonfootprintVehicle?.recordset ||
    chartData?.carboonfootprintVehicle ||
    [];
  const data1 = apiData1.map((item) => ({
    name: item.DATA, // vehicle number
    uv: item.VAL, // carbon footprint value
  }));
  const itemsPerPage = 10;
  const maxPage = Math.floor(data1?.length / itemsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, maxPage));
  };

  const paginatedData = data1.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );

  return (
    <>
      <Customstyle>
        <div className="head">
          <div className="head1">
            <span style={{ color: "#5F6D8C" }}>Total Carbon Footprint:</span>{" "}
            {chartData?.Totalcarbonfootprint?.[0]?.TotalCb ?? "--"} KgCo2
          </div>
          <div className="Custom">
            <div className="dropstyle">
              {" "}
              <Form.Item
                label=""
                name="dropdown"
                rules={[
                  { required: true, message: "Please select an option!" },
                ]}
              >
                <Select
                  placeholder="Custom Range"
                  className="plc"
                  style={{ width: "240px" }}
                  defaultValue={duration}
                  onChange={(values) => {
                    setDuration(values);
                  }}
                >
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="dropstyle1">
              <Space direction="vertical" size={12}>
                <RangePicker
                  value={selectedDate}
                  onChange={(date, dateString) => setSelectedDate(date)}
                />
              </Space>
            </div>
            <div className="badg-hover-wrapper">
              {/* <img src={upload} alt="Upload Icon" className="hover-image" onClick={() => handleDownloadChart("Export Chart")} /> */}

              <Badge
                count={filterCount}
                className="badg"
                onClick={handleclickfilter}
              >
                <Avatar
                  shape="circle"
                  size="medium"
                  src={filtericon}
                  onClick={() => setFilterModalOpen(true)}
                  className="filterstyle"
                />
              </Badge>
            </div>
          </div>
        </div>
        <br />
        <div id="Export Chart1">
          <Spin spinning={loading}>
            <Card
              style={{
                width: "100%",
                height: "100%",
                overflowX: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p className="textstyle">Carbon Footprint by Vehicle</p>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "23px" }}
                >
                  <LeftOutlined
                    style={{ cursor: "pointer" }}
                    onClick={handlePrev}
                    disabled={currentPage === 0}
                  />
                  <RightOutlined
                    style={{ cursor: "pointer" }}
                    onClick={handleNext}
                    disabled={currentPage === maxPage - 1}
                  />
                  <img
                    src={upload}
                    alt="Upload Icon"
                    className="hover-image"
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart1",
                        "Carbon Footprint by Vehicle",
                      );
                    }}
                  />
                </div>
              </div>
              {/* Inner container with a wider width */}
              <div style={{ width: "100%" }}>
                <ResponsiveContainer width="100%" height={300}>
                  <AreaChart
                    data={paginatedData}
                    margin={{ top: 20, right: 10, left: 10, bottom: 10 }}
                    style={{ cursor: "pointer" }}
                  >
                    <defs>
                      <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="rgba(37, 169, 114, 1)"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="rgba(217, 217, 217, 0)"
                          stopOpacity={0.8}
                        />
                      </linearGradient>
                    </defs>
                    <XAxis
                      dataKey="name"
                      tickLine={false}
                      interval={0}
                      tick={{
                        textAnchor: "end", // Center align text
                        fontSize: 11,
                      }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tickFormatter={(value) => Math.round(value)}
                    />

                    <Tooltip content={<CustomTooltip />} />
                    <Area
                      type="monotone"
                      dataKey="uv"
                      stroke="rgba(37, 169, 114, 1)"
                      fill="url(#colorUv)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Spin>
        </div>
        <div id="Export Chart2">
          <Spin spinning={loading}>
            <Card style={{ overflowX: "auto" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p className="textstyle">Carbon Footprint by Consignor</p>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <img
                    src={upload}
                    alt="Upload Icon"
                    className="hover-image"
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart2",
                        "Carbon Footprints by Consignee",
                      );
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "400px", // Allow height to adjust dynamically
                }}
                className="chart-container"
              >
                <VerticalChart
                  data={chartData?.CarbonFootprintConsignee?.map(
                    (item, index) => ({
                      Vehicle_No: item.DATA,
                      value: item.VAL,
                    }),
                  )}
                  width="100%"
                  height={400}
                  barColor="blue"
                  dataKey="value"
                />
              </div>
            </Card>
          </Spin>
        </div>
        <br />
        <div id="Export Chart3">
          <Spin spinning={loading}>
            <Card style={{ overflowX: "auto" }}>
              <div style={{ position: "relative", width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p className="textstyle">
                    Carbon Footprint by Vehicle Type (KgCO2)
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "23px",
                    }}
                  >
                    <img
                      src={upload}
                      alt="Upload Icon"
                      className="hover-image"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Export Chart3",
                          "Carbon Footprint by Vehicle Type (KgCO2)",
                        );
                      }}
                    />
                  </div>
                </div>

                {/* Responsive container with relative positioning */}
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "400px",
                  }}
                >
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        dataKey="VAL"
                        nameKey="DATA"
                        startAngle={180}
                        endAngle={0}
                        data={chartData?.CarbonFootprintVehicleType}
                        cx="50%"
                        cy="80%"
                        outerRadius={240}
                        innerRadius={120}
                        label={renderCustomizedLabel}
                        style={{ cursor: "pointer" }}
                      >
                        {chartData?.CarbonFootprintVehicleType?.map(
                          (entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ),
                        )}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>

                  {/* Centered image based on cx and cy */}
                  <img
                    src={legco2}
                    alt="Legend CO2"
                    style={{
                      position: "absolute",
                      left: "50%",
                      top: "70%",
                      transform: "translate(-50%, -50%)",
                      width: "60px",
                      height: "60px",
                      pointerEvents: "none",
                    }}
                    className="legend-image"
                  />
                </div>
              </div>
            </Card>
          </Spin>
        </div>
        <br /> <br />
        <div className="header">
          <div className="head2">
            <p>{total} Carbon Footprints</p>
          </div>
          <div className="Custom2">
            <Spin spinning={CSVLoader}>
              <img
                src={upload}
                alt="Export"
                className="hoverimage1"
                onClick={() => {
                  if (!exportAllowed) return;
                  prepareCSV();
                }}
                style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
              />
            </Spin>
            <CSVLink
              data={CSVList}
              filename={"CarbonfootprintReport.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </div>
        <StyledTable
          dataSource={TableData?.CarbonTable}
          columns={OfficeColumn}
          pagination={false}
          onChange={(pagination, filters, sorter) => {
            setTableSort({
              field: sorter.field,
              order: sorter.order,
            });
          }}
        />
        <ReusablePagination
          pageSize={PageSize}
          handlePageSizeChange={handlePageSizeChange}
          currentPage={currentPage}
          total={total}
          handlePageChange={handlePageChange}
        />
      </Customstyle>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              form.resetFields();
              setFormValues({});
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Form
          form={form}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            getFilterCount();
            setFormValues(allvalues);
          }}
          //  initialValues={formValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Vehicle" name="vehicle">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={vehicleList?.map((item) => ({
                    label: item.REGNO,
                    value: item.VEHID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignor" name="consignor">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Transporter" name="transporter">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Duration" name="Duration">
                <Select>
                  {Duration?.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Date Range" name="Daterange">
                <RangePicker />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Trip Type" name="tripType">
                <Select
                  className="w-100"
                  showSearch
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                >
                  <Option value={2}>Safari</Option>
                  <Option value={1}>Local</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Driver" name="driver">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={driverList?.map((item) => ({
                    label: item.FULLNM,
                    value: item.UID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Trip Code" name="Tripcode">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default Carbonfootprints;
